import type { SpartanProductCustomizeExteriorTwoTone } from '@/app/lcv/components/sections/spartan/products/customize/types';

export const SPARTAN_PRODUCT_CUSTOMIZE_LABELS = {
  compare: 'เปรียบเทียบ',
  calculator: 'คำนวณค่างวด',
  selectGrade: 'รุ่นรถ',
  selectColor: 'เลือกสีภายนอก',
  selectInteriorColor: 'เลือกสีภายใน',
  colorPrefix: 'สีภายนอก ',
  interiorColorPrefix: 'สีภายใน ',
  totalPricePrefix: 'ราคารวม',
  previewCarousel: 'ภาพตัวอย่างรถ',
  previewSlide: (label: string, current: number, total: number) =>
    `${label}, ${current} จาก ${total}`,
  previous: 'Previous',
  next: 'Next',
  close: 'Close',
} as const;

export const SPARTAN_MU_X_RS_EXTERIOR_COLOR_TWO_TONE = {
  subCategoryTitle: 'rs',
  solidColor: '#010101',
} as const satisfies SpartanProductCustomizeExteriorTwoTone;

/** Mock interior color chip shown while preview view is interior. */
export const SPARTAN_PRODUCT_CUSTOMIZE_INTERIOR_COLOR_MOCK = {
  name: 'ดำ',
  swatchColor: '#383838',
} as const;

export const SPARTAN_PRODUCT_CUSTOMIZE_PREVIEW_VIEW_LABELS = {
  front: 'ด้านหน้า',
  rear: 'ด้านหลัง',
  interior: 'ภายใน',
} as const;
